// import { Avatar, Container,ToggleButton,Typography,Box,FormControl } from "@mui/material";
import {
  Avatar,
  Box,
  Container,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  CardContent,
  CircularProgress,
  Divider,
  Button
} from "@mui/material";
import React, { useState, useRef, useEffect, useCallback } from "react";
import { Card, Row } from "react-bootstrap";
import { useLocation, useNavigate, Link } from "react-router-dom";
import LineChart from "../charts/Linechart";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { endLoading, startLoading } from "../../../Redux/loadingSlice";
import Axios from "../../../config/axios";
import { UrlConstant } from "../../../commom/UrlConstant";
import { calculateCryptoChange, getUserFromLocalStorage } from "../../../utils/utils";
import axios from "axios";
import TransactionHistoryTable from "../Tabels/PortfolioTransactionTabel";
import CandleStickIcon from "../../../commom/Assets/images/CandleStick.png";
import LinChartIcon from "../../../commom/Assets/images/LineChart.png";
import CandlestickChart from "../charts/CandlestickChart";
import { extractQuoteWithFallback } from "../../../helpers/cryptoQuoteHelper";
import { usePriceFormatter } from "../../../hooks";
import { formatPercentage } from "../../../utils/formatting";

const BAR_CHART_KEY = "0J7lfEpAefOuHSE6uSHdiW_5N0sThxfa";
const YAHOO_FINANCE_KEY = "W6WQ7T5PIt63txWaMW9yVsDCVVYbUD81i0eERo32";
const BASE_URL = "https://yfapi.net/ws/insights/v1/finance/insights";


function PortfolioStockDetail() {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigation = useNavigate();
  const currencyInfo = useAppSelector((state) => state.currency);
  const currencyKey = currencyInfo.effectiveCurrency || 'USD';
  const formatter = usePriceFormatter()

  const [stockDetail, setStockDetail] = React.useState<any>({});
  const [loading, setLoading] = useState(false);
  const [chartData, setChartData] = useState<any>([]);
  const [tickerData, setTickerData] = useState<any>([]);
  const [tickerDataAll, setTickerAllData] = useState<any>([]);
  const [transactionHistory, setTransactionHistory] = useState<any>([]);
  const [selection, setSelection] = useState<string>("1 Month");
  const [expanded, setExpanded] = useState(false);
  const scrollRef = useRef<HTMLDivElement>(null);
  const [crypto, setCrypto] = useState<any>(null);
  const [graphType, setGraphType] = useState<"line" | "candlestick">("line");
  const [candleChartData, setCandleChartData] = useState<any[]>([]);

  const user = getUserFromLocalStorage();


  const handleselect = (
    event: React.MouseEvent<HTMLElement>,
    newselection: string
  ) => {
    setChartData([]);
    setSelection(newselection);
  };

  const stockInfo = location.state?.stockInfo;
  const type = (stockInfo.type || "stock").toLowerCase();
  const stock = location.state?.symbol;
  const externalID = stockInfo.cmcId;
  const icon = location.state?.icon;
  const title = location.state?.title
  const currencyPair = stockInfo?.currencyPair
  const stockId = stockInfo?.stockId

  const quoteData = extractQuoteWithFallback(crypto as any, currencyKey);
  const currentPrice = quoteData?.price ?? stockInfo?.quote?.price;

  function calculatePriceDetails(tickerData) {
    const lastPrice = parseFloat(tickerData?.Last || "0.00");
    const previousClose = parseFloat(tickerData?.PreviousClose || "0.00");
    const diffAmount = lastPrice - previousClose;
    const percentage = (diffAmount * 100.0) / previousClose;

    return {
      lastPrice,
      previousClose,
      diffAmount,
      percentage
    };
  }

  const fetchCryptoLoanByStock = async () => {
    if (!stockId) {
      return [];
    }
    try {
      const response = await Axios.get(`${UrlConstant.Crypto.GetCryptoLoanByStock}?stockId=${stockId}`);
      return response?.data?.data?.loanData || []
    } catch (error: any) {
      console.error("Crypto loan by stock error: ", error)
      return []
    }
  }

  const getTransactionHistory = async () => {
    dispatch(startLoading())
    setLoading(true)

    try {
      if (type === "crypto") {
        // Fetch orders & loan-by-stock in parallel
        const [ordersRes, loanData] = await Promise.all([
          Axios.get(
            `${UrlConstant.Crypto.GetCryptoOrders}?status=completed&currencyPair=${currencyPair}`
          ),
          fetchCryptoLoanByStock()
        ])

        const resData = ordersRes.data
        if (resData.success === true) {
          const formattedOrders = resData.orders.map((order: any) => {
            const filledQty = order.filledQuantity ?? order.quantity ?? 0
            const avgPrice = order.avgPrice ?? 0

            let pnlPercent = 0
            let isPositive = false

            if (currentPrice && avgPrice) {
              pnlPercent = ((currentPrice - avgPrice) / avgPrice) * 100
              isPositive = pnlPercent >= 0
            }

            // Match boosterLoanId with loanData.loanId
            const matchedLoan = loanData.find(
              (loan: any) => loan.loanId === order.boosterLoanId
            )

            return {
              createdAt: order.createdAt,
              value: currentPrice,
              Qty: filledQty,
              isPositive,
              pnlPercent: Number(pnlPercent.toFixed(2)),
              // Use remainingLoanAmount if found, else fallback to 0
              loanAmount: matchedLoan?.remainingLoanAmount ?? 0,
              order,
              type: order.side
            }
          })

          setTransactionHistory(formattedOrders)
        }
      } else {
        // Stock flow
        const data = {
          accountId: user?.tradingblock_application_id,
          pageSize: "50",
          pageIndex: "0",
          symbol: stock
        }

        const response = await Axios.post(
          UrlConstant.Portfolio.TransactionHistory,
          data
        )

        const resData = response.data
        if (resData.status === true) {
          setTransactionHistory(resData.data)
        }
      }
    } catch (error: any) {
      console.error("ERRR : ", error)
    } finally {
      dispatch(endLoading())
      setLoading(false)
    }
  }

  const fetchAssetDetail = async () => {
    if (!type) return;

    dispatch(startLoading());
    setLoading(true);

    try {
      if (type === "crypto" && externalID) {
        // ---- CRYPTO API ----
        const url = UrlConstant.Crypto.GetCryptoMarketDetail.replace("{externalId}", externalID);
        const response = await Axios.get(url);
        const cryptoData = response.data?.data?.[0] || null;
        setCrypto(cryptoData);
      }

      else if (type === "stock" && stock) {
        // ---- STOCK API ----
        const [stockRes, tickerRes] = await Promise.all([
          Axios.get(UrlConstant.Stock.GetStockDetail.replace("{0}", stock)),
          Axios.get(UrlConstant.Stock.GetTiker.replace("{0}", stock)),
        ]);

        const tickerData = tickerRes.data?.data?.[0];
        if (tickerData) {
          setTickerData(calculatePriceDetails(tickerData));
          setTickerAllData(tickerData);
        }

        if (stockRes.data?.result) {
          setStockDetail(stockRes.data.data);
        }
      }
    } catch (error) {
      console.error("Error fetching asset detail:", error);
      if (type === "crypto") setCrypto(null);
    } finally {
      dispatch(endLoading());
      setLoading(false);
    }
  };

  const getUrlRange = (): string => {
    const now = new Date(new Date().setDate(new Date().getDate()));
    let endPoint = "";

    const formatDate = (date: Date) =>
      date.toISOString().split("T")[0];

    const adjustDate = (date: Date, adjust: { days?: number; months?: number; years?: number }) => {
      if (adjust.days) date.setDate(date.getDate() + adjust.days);
      if (adjust.months) date.setMonth(date.getMonth() + adjust.months);
      if (adjust.years) date.setFullYear(date.getFullYear() + adjust.years);
      return date;
    };
    console.log(selection, adjustDate(new Date(now), { days: -1 }), "selectionselection")
    switch (selection) {
      case "1 Day":
        endPoint = `/range/15/minute/${formatDate(adjustDate(new Date(now), { days: -1 }))}/${formatDate(now)}`;
        break;
      case "5 Day":
        endPoint = `/range/1/day/${formatDate(adjustDate(new Date(now), { days: -8 }))}/${formatDate(now)}`;
        break;
      case "1 Month":
        endPoint = `/range/1/day/${formatDate(adjustDate(new Date(now), { months: -1 }))}/${formatDate(now)}`;
        break;
      case "6 Month":
        endPoint = `/range/1/week/${formatDate(adjustDate(new Date(now), { months: -6 }))}/${formatDate(now)}`;
        break;
      case "1 Year":
        endPoint = `/range/1/month/${formatDate(adjustDate(new Date(now), { years: -1 }))}/${formatDate(now)}`;
        break;
      case "5 Years":
        endPoint = `/range/1/month/${formatDate(adjustDate(new Date(now), { years: -5 }))}/${formatDate(now)}`;
        break;
      case "All":
        endPoint = `/range/1/month/1980-01-01/${formatDate(now)}`;
        break;
      default:
        endPoint = `/range/1/day/${formatDate(adjustDate(new Date(now), { days: -1 }))}/${formatDate(now)}`;
    }
    return endPoint;
  };

  const getChartData = async () => {
    dispatch(startLoading());
    if (type === "crypto") {
      try {
        if (!crypto?.symbol) {
          return;
        }
        // Get period for SFOX API (in seconds)
        const getPeriodForSelection = (sel: string): number => {
          switch (sel) {
            case "1 Day": return 900;    // 15 minutes
            case "5 Day": return 3600;    // 1 hour
            case "1 Month": return 86400;  // 1 day
            case "6 Month": return 86400;  // 1 day
            case "1 Year": return 86400;   // 1 day
            case "5 Years": return 86400;  // 1 day
            case "All": return 86400;      // 1 day
            default: return 86400;
          }
        };

        // Get time range for SFOX API
        const getTimeRangeForSelection = (sel: string): { startTime: number; endTime: number } => {
          const now = Math.floor(Date.now() / 1000);
          let startTime = 0;

          switch (sel) {
            case "1 Day":
              startTime = now - (1 * 24 * 60 * 60);
              break;
            case "5 Day":
              startTime = now - (5 * 24 * 60 * 60);
              break;
            case "1 Month":
              startTime = now - (30 * 24 * 60 * 60);
              break;
            case "6 Month":
              startTime = now - (180 * 24 * 60 * 60);
              break;
            case "1 Year":
              startTime = now - (365 * 24 * 60 * 60);
              break;
            case "5 Years":
              startTime = now - (5 * 365 * 24 * 60 * 60);
              break;
            case "All":
              startTime = now - (10 * 365 * 24 * 60 * 60);
              break;
            default:
              startTime = now - (30 * 24 * 60 * 60);
          }

          return { startTime, endTime: now };
        };

        // Convert crypto symbol to SFOX pair format (e.g., BTC -> btcusd)
        const pair = `${crypto.symbol.toLowerCase()}usd`;

        // Get time range and period for the selected interval
        const { startTime, endTime } = getTimeRangeForSelection(selection);
        const period = getPeriodForSelection(selection);

        // Call SFOX API
        const wolfpackUrl = UrlConstant.Crypto.Candlesticks;
        const params = {
          pair: pair,
          startTime: startTime,
          endTime: endTime,
          period: period,
          currency: currencyInfo.effectiveCurrency
        };

        const res = await Axios.get(wolfpackUrl, { params });

        const apiData = res.data?.data || [];

        const candleData = apiData.map((item: any) => ({
          x: new Date(item.start_time * 1000).toISOString(),
          y: [
            parseFloat(item.open_price),
            parseFloat(item.high_price),
            parseFloat(item.low_price),
            parseFloat(item.close_price),
          ],
          v: parseFloat(item.volume || 0),
        }));

        const lineData = apiData.map((item: any) => ({
          x: new Date(item.start_time * 1000).toISOString(),
          y: parseFloat(item.close_price),
        }));
        setCandleChartData(candleData);
        setChartData(lineData);
      } catch (error) {
        console.error("Error fetching crypto chart data:", error);
        setChartData([]);
      } finally {
        dispatch(endLoading());
      }
      return;
    }
    console.log(getUrlRange(), "getUrlRange()")
    const fetchChartData = async (retryCount = 2) => {
      let currentDate = new Date();
      let retries = 0;

      while (retries <= retryCount) {
        // Adjust date range for the "1 Day" case
        const adjustedDate = new Date(currentDate);
        adjustedDate.setDate(currentDate.getDate() - retries);

        const startDate = adjustedDate.toISOString().split("T")[0];
        const endDate = new Date().toISOString().split("T")[0];

        const url = `https://api.polygon.io/v2/aggs/ticker/${stock}/range/15/minute/${startDate}/${endDate}?apiKey=${BAR_CHART_KEY}&sort=asc&limit=5000`;

        try {
          const response = await axios.get(url);

          if (response.data.queryCount > 0) {
            const apiResponse = response.data.results;
            const chartData = apiResponse.map(item => ({
              x: new Date(item.t), // Convert Unix timestamp to Date
              y: item.c // Extract closing price "c"
            }));

            console.log(chartData, "chartData");
            setChartData(chartData);
            return;
          } else {
            console.log(`No data for date range: ${startDate} - ${endDate}, retrying...`);
          }
        } catch (error) {
          console.error(`Error fetching chart data for range ${startDate} - ${endDate}:`, error);
        }

        retries++;
      }

      console.log("No data found after all retries");
      setChartData([]);
    };

    if (selection === "1 Day") {
      await fetchChartData();
    } else {

      try {
        const url = `https://api.polygon.io/v2/aggs/ticker/${stock}${getUrlRange()}?apiKey=${BAR_CHART_KEY}&sort=asc&limit=5000`;
        const response = await axios.get(url);
        console.log(response.data, "response.dataresponse.data")
        const apiResponse = response.data.results
        const chartData = apiResponse.length && apiResponse.map(item => ({
          x: new Date(item.t),
          y: item.c
        }));

        console.log(chartData, "chartDatachartDatachartData")
        setChartData(chartData || []);
      } catch (error) {
        console.error("Error fetching chart data:", error);
      } finally {
        dispatch(endLoading());
      }
    }
  };

  const onBuySell = (tradType) => {
    if (type?.toUpperCase() === "CRYPTO") {
      navigation("/crypto-detail", {
        state: { externalID, tradType },
      });
    } else {
      navigation("/stockdetail", {
        state: {
          symbol: stock,
          icon: icon,
          title: "Portfolio",
          tradType: tradType,
        },
      });
    }
  }

  const handleGraphTypeChange = useCallback((
    event: React.MouseEvent<HTMLElement>,
    newGraphType: "line" | "candlestick" | null
  ) => {
    if (newGraphType) {
      setGraphType(newGraphType);
    }
  }, []);

  useEffect(() => {
    getTransactionHistory();
    fetchAssetDetail();
  }, [type, stock, externalID]);

  useEffect(() => {
    getChartData();
  }, [selection, type, crypto?.symbol]);

  const { changeAmount, changePercentage } = calculateCryptoChange(
    quoteData?.price,
    quoteData?.percent_change_24h
  );

  const isCrypto = type === "crypto";
  const headerIcon = isCrypto ? crypto?.logo : icon;
  const headerSymbol = isCrypto ? crypto?.symbol : stock;
  const headerName = isCrypto ? crypto?.name : stockDetail?.displayName;
  const subLabel = isCrypto ? crypto?.symbol : `${stockDetail?.stockExchangeCode}:${stockDetail?.symbol}`;
  const priceValue = isCrypto
    ? (quoteData?.price !== undefined && quoteData?.price !== null ? `${formatter.price(quoteData?.price).display}` : 'N/A')
    : `$ ${tickerData?.lastPrice}`;
  const changeText = isCrypto
    ? `${formatter.display(changeAmount, { showSign: true })}(${formatPercentage(changePercentage, { showSign: true })})`
    : `${formatter.display(tickerData.diffAmount, { showSign: true })}(${formatPercentage(tickerData.percentage, { showSign: true })})`;
  const changeColor = isCrypto
    ? (changeAmount === 0 ? "#FFFFFF" : changeAmount > 0 ? "#4edf6d" : "#ff2a2a")
    : (tickerData.diffAmount > 0 ? "#4edf6d" : "#ff2a2a");

  return (
    <Box className="bg-color" minHeight='calc(100vh - 71px)' display="flex">
      <Container
        maxWidth={false}
        className="bg-color p-3 px-5"
        style={{
          // display: "flex",
          height: "fit-content",
          width: "70%",
        }}
      >
        <Typography
          className="text-secondary"
          sx={{ marginTop: "30px", marginBottom: "30px" }}
        >

          <span
            onClick={() => navigation(-1)}
            style={{ color: "#4A7AF2", cursor: "pointer" }}
          >
            {title}
          </span>
          <span> / {stock}</span>
        </Typography>

        <Container
          style={{ width: "100%", left: "0", margin: "0" }}
          className="p-0"
        >
          <Box>
            {/* Top header row */}
            <Box display="flex" alignItems="start" justifyContent="space-between">
              {/* Left side: Icon + Name */}
              <Box className="text-white">
                <Box display="flex" alignItems="center" gap="20px" mb={2}>
                  {headerIcon ? (
                    <Avatar
                      alt={headerSymbol}
                      src={headerIcon}
                      sx={{ width: 64, height: 64, backgroundColor: "white", objectFit: "fill" }}
                      className="icon"
                    />
                  ) : (
                    <Box sx={{ width: 64, height: 64, display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#f0f0f0", borderRadius: "50%" }}>
                      <Typography variant="h6" sx={{ fontWeight: "bold", color: "#212529" }}>{headerSymbol}</Typography>
                    </Box>
                  )}
                  <Box>
                    <Typography mb={1} variant="h5">
                      {headerName}
                    </Typography>
                    <Typography variant="body1" className="text-secondary">
                      {subLabel}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* Right side: Price + Change */}
              <Box className="text-white" display="flex" gap="10px" alignItems="center">
                <Typography variant="h5" textAlign="end">{priceValue}</Typography>
                <Typography variant="h5" style={{ color: changeColor }}>{changeText}</Typography>
              </Box>
            </Box>

            {/* New row for Chart type toggle (right-aligned, like CryptoDetail) */}
            <Box display="flex" justifyContent="flex-end" mt={1}>
              <ToggleButtonGroup
                value={graphType}
                exclusive
                onChange={handleGraphTypeChange}
                aria-label="Chart type"
              >
                <ToggleButton value="line" style={{ width: "50px", height: "35px", padding: "10px" }}>
                  <img src={LinChartIcon} alt="Line Chart" style={{ width: "22px" }} />
                </ToggleButton>
                <ToggleButton value="candlestick" style={{ width: "50px", height: "35px", padding: "10px" }}>
                  <img src={CandleStickIcon} alt="Candlestick Chart" style={{ width: "22px" }} />
                </ToggleButton>
              </ToggleButtonGroup>
            </Box>
          </Box>
          <Row className="dark-tbl no-border p-0 mt-5">
            <Card
              className="custom-card overflow-hidden bg-color w-100"
              style={{ height: "fit-content" }}
            >
              <Card.Body className="ps-12 p-2 h-100">
                {/* Chart */}
                {graphType === "line" ? (
                  <LineChart
                    data={chartData}
                    timeline={selection}
                    lineColor={changeAmount > 0 ? "#4edf6d" : changeAmount === 0 ? "#FFFFFF" : "#ff2a2a"}
                  />
                ) : (
                  <CandlestickChart
                    data={candleChartData}
                    timeline={selection}
                  />
                )}
                <hr style={{ borderColor: "#FFFFFF", borderWidth: "1px" }}></hr>
                <Box mb={1}>
                  <ToggleButtonGroup
                    // className="border-white"
                    // color="primary"
                    // fullWidth
                    value={selection}
                    exclusive
                    onChange={handleselect}
                    aria-label="Platform"
                  >
                    <ToggleButton value="1 Day">1 Day</ToggleButton>
                    <ToggleButton value="5 Day">5 Day</ToggleButton>
                    <ToggleButton value="1 Month">1 Month</ToggleButton>
                    <ToggleButton value="6 Month">6 Month</ToggleButton>
                    <ToggleButton value="1 Year">1 Year</ToggleButton>
                    {type === "crypto" ? null :
                      <>
                        <ToggleButton value="5 Years">5 Years</ToggleButton>
                        <ToggleButton value="All">Max</ToggleButton>
                      </>
                    }
                  </ToggleButtonGroup>
                </Box>
              </Card.Body>
            </Card>
          </Row>
        </Container>

        {/* <Container style={{ width: "70%", left: "0", margin: "0" }}>
            <TotalFunds />
          </Container> */}
        <TransactionHistoryTable transactionHistory={transactionHistory} />

      </Container>
      <Container style={{ width: "30%", paddingTop: "20px" }}>
        <Box width="100%">
          <Typography
            component="h1"
            fontSize={24}
            mb={2}
            className="text-white"
          >
            {isCrypto ? 'Crypto Details' : 'Stock Details'}
          </Typography>
          <Card className="card" style={{ width: "100%", minHeight: '300px', paddingBottom: "0px" }}>
            <CardContent sx={{ padding: "20px" }}>
              <Box display={"flex"} justifyContent={"space-between"} paddingBottom={"10px"}>
                <Typography className="text-secondary">Total Qty.</Typography>
                <Typography className="text-white">{formatter.quantity(stockInfo?.quantity).display}</Typography>
              </Box>
              <Box display={"flex"} justifyContent={"space-between"} paddingBottom={"10px"}>
                <Typography className="text-secondary">Avg Price.</Typography>
                <Typography className="text-white">{formatter.price(stockInfo?.quote?.lastPrice).display}</Typography>
              </Box>
              {/* <Box display={"flex"} justifyContent={"space-between"} paddingBottom={"10px"}>
                <Typography className="text-secondary">Profit/Loss</Typography>
                <Typography className="text-white">
                  <span style={{ color: stockInfo.gainPercent == 0 ? " " : stockInfo.gainPercent > 0 ? "#4EDF6D" : "red", fontWeight: 'bold' }}>{formatPrice(stockInfo.gainPercent)}%</span>
                </Typography>
              </Box> */}
              <Box display={"flex"} justifyContent={"space-between"} paddingBottom={"10px"}>
                <Typography className="text-secondary">Invested</Typography>
                <Typography className="text-white">{formatter.balance(stockInfo?.costValue).display}</Typography>
              </Box>
              <Box display={"flex"} justifyContent={"space-between"} paddingBottom={"10px"}>
                <Typography className="text-secondary">Market Value</Typography>
                <Typography className="text-white">{formatter.balance(stockInfo?.value).display}</Typography>
              </Box>
              <Box display={"flex"} justifyContent={"space-between"} paddingBottom={"10px"}>
                <Typography className="text-secondary">Portfolio Diversity</Typography>
                <Typography className="text-white">{formatPercentage(stockInfo?.percentage)}</Typography>
              </Box>
              <Box display={"flex"} justifyContent={"space-between"} paddingBottom={"10px"}>
                <Typography className="text-secondary">Today's return</Typography>

                <Box display="flex" alignItems="center">
                  <Typography className="text-white" style={{ marginRight: 8 }}>
                    {formatter.display(stockInfo?.todayReturnValue, { showSign: true })}
                  </Typography>
                  <Typography className="text-white">
                    <span
                      style={{
                        color:
                          stockInfo?.todayReturnPercent > 0
                            ? "#4EDF6D"
                            : stockInfo?.todayReturnPercent < 0
                              ? "red"
                              : "inherit",
                        fontWeight: "bold"
                      }}
                    >
                      ({formatPercentage(stockInfo?.todayReturnPercent)})
                    </span>
                  </Typography>
                </Box>
              </Box>

              <Box display={"flex"} justifyContent={"space-between"} paddingBottom={"10px"}>
                <Typography className="text-secondary">Total return</Typography>

                <Box display="flex" alignItems="center">
                  <Typography className="text-white" style={{ marginRight: 8 }}>
                    {formatter.display(stockInfo?.gainValue, { showSign: true })}
                  </Typography>
                  <Typography className="text-white">

                    <span
                      style={{
                        color:
                          stockInfo?.gainPercent > 0
                            ? "#4EDF6D"
                            : stockInfo?.gainPercent < 0
                              ? "red"
                              : "inherit",
                        fontWeight: "bold"
                      }}
                    >
                      ({formatPercentage(stockInfo?.gainPercent)})
                    </span>
                  </Typography>
                </Box>
              </Box>
              {/* <Box display={"flex"} justifyContent={"space-between"} paddingBottom={"10px"}>
                <Typography className="text-secondary">Cash</Typography>
                <Typography className="text-white">{stockInfo?.cash?.toFixed(2)}</Typography>
              </Box>
              <Box display={"flex"} justifyContent={"space-between"} paddingBottom={"10px"}>
                <Typography className="text-secondary">Booster Loan</Typography>
                <Typography className="text-white">{stockInfo?.loanDetail?.loanAmount}</Typography>
              </Box> */}
              <Divider sx={{ borderColor: '#FFFFFF70', marginY: 1 }} />
              <Box gap={2} display={"flex"} justifyContent={"space-between"} marginTop={"20px"}>
                <Button
                  onClick={() => { onBuySell("Buy") }}
                  //  sx={{marginTop:'20px'}}

                  variant="contained"
                  // color="primary"
                  // fullWidth
                  className="text-dark  fw-700 fs-18  btn mb-10"
                  sx={{ width: '100%', bgcolor: "#4edf6d !important", padding: '10px !important' }}
                >
                  Buy
                </Button>
                <Button
                  onClick={() => { onBuySell("Sell") }}
                  //  sx={{marginTop:'20px'}}

                  variant="contained"
                  // color="primary"
                  // fullWidth
                  className="text-dark  fw-700 fs-18  btn mb-10"
                  sx={{ width: '100%', bgcolor: "#FF2A2A !important", padding: '10px !important' }}
                >
                  Sell
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Container>

      {loading && (
        <Box
          position="fixed"
          top={0}
          left={0}
          width="100vw"
          height="100vh"
          bgcolor="rgba(0, 0, 0, 0.5)" // Semi-transparent black background
          display="flex"
          justifyContent="center"
          alignItems="center"
          style={{
            backdropFilter: "blur(5px)", // Blur effect
            zIndex: 9999, // Ensures the loader stays above all elements
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      )}

    </Box>
  );
}
export default PortfolioStockDetail;
